/* import { Button } from "@mui/material"; */
import RegistryInputs from './registryInputs/registryInputs';
import i18n from '../../utils/i18n';
import { withTranslation } from 'react-i18next';

import logo from '../images/bookkeepie-logo.svg';

import classes from './providerEntry.module.scss';

const ProviderRegister = () => {
	return (
		<div className={classes.EntryContainer}>
			<div className={classes.EntryHeader}>
				<img src={logo} alt="bookkeepie" className={classes.EntryLogo} />
				<div className={classes.RegButton}>
					<span className={classes.MediumText} style={{ marginRight: '12px' }}>
						{i18n.t('general.doyouhaveanaccount')}
					</span>
					{/* <span className={classes.Blue14}> */}
					<a className={classes.noDecoration && classes.Blue14} href="/">
						{i18n.t('general.iamloggingin')}
					</a>
					{/* </span> */}
				</div>
			</div>
			<RegistryInputs />

			<div className={classes.LoginBlueBox}></div>
		</div>
	);
};

export default withTranslation()(ProviderRegister);
